/* eslint-disable no-param-reassign */

xplenty.directive('nameDescriptionEditor', [
  '$rootScope',
  '$window',
  '$translate',
  function ($rootScope, $window, $translate) {
    return {
      require: '?^^form',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/name-description-editor.html'),

      replace: true,

      scope: {
        item: '=ngModel',
        disableValidation: '=?',
      },

      link(scope, element, attrs, form) {
        scope.form = form;

        const namePlaceholder = attrs.namePlaceholder || 'name-description-editor.placeholders.name';
        const descriptionPlaceholder =
          attrs.descriptionPlaceholder || 'name-description-editor.placeholders.description';

        $translate([namePlaceholder, descriptionPlaceholder]).then(function (t) {
          scope.namePlaceholder = t[namePlaceholder];
          scope.descriptionPlaceholder = t[descriptionPlaceholder];
        });

        scope.optionalName = angular.isUndefined(attrs.optionalName) ? false : scope.$eval(attrs.optionalName);
        // Description is always optional by default
        scope.optionalDescription = angular.isUndefined(attrs.optionalDescription)
          ? true
          : scope.$eval(attrs.optionalDescription);
      },
      controller: [
        '$scope',
        function ($scope) {
          $scope.showDescription = false;

          $scope.toggleDescription = function () {
            $scope.showDescription = !$scope.showDescription;
          };
        },
      ],
    };
  },
]);
